module.exports = __webpack_public_path__ + "static/7-95393cd9384da2d03e36b9bc6932c469.jpg";